import m1 from './../assets/Images/masters/m1.png';
import m2 from './../assets/Images/masters/m2.png';
import m3 from './../assets/Images/masters/m3.png';
import m4 from './../assets/Images/masters/m4.png';

import e1 from './../assets/Images/events/P1E1B1.png';   
import e4 from './../assets/Images/events/P1E4B1.jpeg';   

import P3E1B1 from './../assets/Images/events/P3E1B1.jpeg';  
import P3E2B1 from './../assets/Images/events/P3E2B1.jpg';  
import P3E3B1 from './../assets/Images/events/P3E3B1.jpeg';   
 
import P4E3B1 from './../assets/Images/events/P4E3B1.jpeg';   


import P2 from './../assets/Images/programs/p2.png'
import P3 from './../assets/Images/programs/p3.png'
import P4 from './../assets/Images/programs/p4.png'

export interface Event {
  id: string;
  name: string;
  eventType:string;
  description: string;
  shortDescription: string;
  priceDescription: string;
  isSoldOut?: boolean;
  date: string;
  dateOfEvent: string;
  time: string;
  location: string; 
  locationLink: string;
  priceOfEvent: string;
  priceOfEventRu?: string;
  priceOfEventOnline?: string;
  priceOfEventRuOnline?: string;
  stripeLink: string; 
  kassaLink?: string; 
  stripeLinkOnline?: string; 
  image:string;
  image2?:string;
  image3?:string;
  eventMaster:string;
  videoLink? : string;
  listOfBenefits: string[]
  keyTakeaways: { title: string; description: string }[]; // Key takeaways
}

export interface Program {
  id: string;
  title: string;
  image: string;
  programMasterImage: string;
  dateRange: string;
  startDate: string;
  category: string;
  price: string;
  masterId: string;
  Masters: string;  
  videoLink? : string;
  description: string; 
  stripeLink: string;
  noOfEvents: number;
  events: Event[];
  whatsIncluded: string[];
}

const Programs: Program[] = [
  {
    id: 'program1',
    title: 'Роковые концы: Тайны Русских Гениев',
    image: e1,
    programMasterImage:m1,
    dateRange: '20 марта - 17 апреля ',
    startDate: '2025-03-20',
    category: 'Literature',
    price: '1,800 AED',
    masterId: 'm1',
    whatsIncluded: [
      'Офлайн Занятие',
      'Q&A с Мастером', 
      'Напитки и закуски'
    ],
    
    Masters: 'Владислав Отрошенко', // References Master by ID
    description:
      'Последние дни великих писателей России окутаны мраком загадок и драматических событий. Эта увлекательный программа, основанная на редких архивных документах и глубоких исследованиях, раскрывает драматические судьбы четырёх великих авторов. Дуэль, ставшая смертельным приговором Пушкину. Гоголь — между гением и безумием, сжигающий свой шедевр накануне таинственной смерти. Скандальное убийство и роковая судьба Сухово-Кобылина. Последнее пророчество Толстого и его загадочный уход. Владислав Отрошенко шаг за шагом восстанавливает цепь событий, проливая свет на мистические и роковые обстоятельства, навсегда изменившие историю русской литературы.',
   
    stripeLink: 'https://buy.stripe.com/fZe15Qecv9GNgrm9AK',
    events: [ 
        {
          id: 'event5',
          eventMaster: 'Владислав Отрошенко',
          name: '"Хаджи-Мурат": Последняя Битва Толстого с Судьбой',
          shortDescription: 'Окунитесь в страстный мир последнего шедевра Толстого, где искусство и вера сталкиваются в драматической битве, определившей финал его жизни. «Хаджи-Мурат» — не просто рассказ о гордом воине, но и отражение внутренней борьбы самого автора. Узнайте, какие тайные силы привели величайшего писателя России к гибельному бегству.',
          description: 'Художник и философ—две сущности Льва Толстого—в конце его жизненного пути вступили в непримиримый конфликт. Повесть «Хаджи-Мурат» родилась в ожесточённой борьбе этих Толстовских начал. И в ней, словно пророчество, отразился драматический узор событий, которые приведут её автора, как и главного героя, к гибели на пороге бегства. Мистические, литературные и роковые аспекты последнего творения Толстого — в центре лекции Владислава Отрошенко.',
          date: '17 Апреля',
          dateOfEvent: '2025-04-17',
          time: '19:00',
          location: 'Etihad Museum', 
          eventType: 'Оффлайн',
          locationLink: 'https://maps.app.goo.gl/q82UqkmJch2WNr4y9',
          priceOfEvent: '400 AED',
          priceOfEventRu :'9,000 RUB',
          priceDescription: 'Окунитесь в страстный мир последнего шедевра Толстого, где искусство и вера сталкиваются в битве, определившей его последние дни. «Хаджи Мурат» — не просто повесть, а отражение драматического пути самого писателя. Раскроем тайные силы, приведшие величайшего русского гения к его последнему освобождению.',
          stripeLink: 'https://buy.stripe.com/28oeWGecv1ahgrmaFk',
          kassaLink: 'https://buy.stripe.com/7sI8yi4BV5qxb729B4',
          image: e4,
        
          listOfBenefits: [
            'Оффлайн-лекция',
            'Сессия вопросов и ответов с мастером',
            'Безалкогольные и алкогольные напитки'
          ],
        
          keyTakeaways: [
            {
              title: 'Новый взгляд на наследие Толстого',
              description: 'Получите свежее понимание того, как его последнее произведение переосмыслило его литературный и идеологический путь.'
            },
            {
              title: 'Исследование мистических и философских тем',
              description: 'Раскройте глубинные, почти пророческие измерения последнего литературного шедевра Толстого.'
            },
            {
              title: 'Размышления о судьбе и свободе воли',
              description: 'Изучите философские вопросы, которые не давали покоя Толстому, и как они повлияли на его творчество и жизненные решения.'
            },
            {
              title: 'Понимание связи между искусством и жизнью',
              description: 'Увидите, как личные искания Толстого отразились в его литературе, стирая грани между вымыслом и реальностью.'
            }
          ]
        }
        
    ],
    noOfEvents: 0, // Placeholder
  },
  {
    id: 'program2',
    title: 'Как Архитектура Влияет на Сознание: Форма, Чувства и Функция',
    image: P2,
    programMasterImage:m2,
    dateRange: '8 апреля - 29 апреля',
    startDate: '2025-04-09',
    category: 'Architecture',
    price: '500 AED',
    masterId: 'm2',
    whatsIncluded: [
      'Офлайн Занятие',
          'Q&A с Мастером', 
          'Напитки и закуски'
    ],
    Masters: 'Ирина Коробьина', // References Master by ID
    description:
      'Архитектура  организует жизненное пространство.  В ней мы рождаемся и живем всю свою жизнь. Все мы  являемся ее заказчиками, даже если не строим свои собственные дома или дизайнерские квартиры. Заказ на архитектуру зреет в социуме. Возможно мы об этом и не догадываемся, но это так. Какое общество, какая страна, какое время - такая и архитектура. Ирина Коробьина постоянно обращается к теме воздействия архитектуры на жизнь  человека. Откройте для себя, как пространство, в котором мы живем, выражает своё время и запросы людей, для которых оно создано. Какое время - такая и архитектура! ',
     
    stripeLink: 'https://buy.stripe.com/00gaGq2tNdX34IEfZA', 
    events: [
   
    ],
    noOfEvents: 0, // Placeholder
  },
  {
    id: 'program3',
    title: 'Величие, Секреты, Наследие: Тайные Истории',
    image: P3,
    programMasterImage:m3,
    dateRange: '3 апреля - 14 мая',
    startDate: '2025-04-03',
    category: 'History',
    price: '1,000 AED',
    whatsIncluded: [
      'Офлайн Занятие',
          'Q&A с Мастером', 
          'Напитки и закуски'
    ],
    masterId: 'm3',
    Masters: 'Денис Кобба ', // References Master by ID
    description:
      ' Скрытые силы власти формируют величайшие события истории.  подаваемый слушателям в форме «интеллектуального стендапа», раскрывает три увлекательных аспекта исторического влияния: Тайный мир масонства и закрытых обществ, Темную сторону славы - проявляющаяся в покушениях на известных личностей, Взлет и падение Рима, от эпохи царей до периода империи.  На первый взгляд, эти события принадлежат разным эпохам и не связаны между собой. Но за каждым из них стоят власть, амбиции и неутолимая жажда контроля. Денис Кобба исследует, как эти силы продолжают влиять на формирование общества, раскрывая вечные механизмы власти, тайн и манипуляций, которые выходят за пределы времени.',
    
    stripeLink: 'https://buy.stripe.com/eVa4i2d8rdX3cb68wE',
    events: [
      {
        id: 'P3E2B1',
        eventMaster:'Денис Кобба ',
        name: 'Покушения: Когда Слава Становится Смертельной',
        description:'Какую цену платят знаменитости за своё влияние? На протяжении истории публичные фигуры балансировали между властью, известностью и опасностью, за которые некоторые заплатили наивысшую цену. Эта лекция исследует леденящую реальность покушений: от нападений в древнем мире, до современных угроз, с которыми сталкиваются мировые лидеры.  Мы посмотрим на скрытую цену славы, психологию тех, кто стремится заставить замолчать влиятельные голоса, или хочет войти в историю нападая на представителей звездной элиты. Денис Кобба, представляет зрителям, сложность взаимосвязи между известностью и личной безопасностью, представляя захватывающий примеры самых ярких и известных нападений в истории, и современных проблем защиты публичных персон.',
        shortDescription: 'Раскройте обратную сторону известности, исследуя громкие покушения в истории на публичных деятелей, политиков, монархов, актеров и бизнесменов… Раскройте психологию лиц совершивших множество нападений на представителей селебрити разных эпох.',
        date: '24 Апреля  ',
        dateOfEvent: '2025-04-24',
        time: '19:00 ',
        location: 'Etihad museum', 
        eventType:'Интерактивная Трансляция',
        locationLink: 'https://maps.app.goo.gl/TFGEStx1q5qb8krG9',
        priceOfEvent: '100 AED',
        priceOfEventRu :'2,000 RUB',
        priceOfEventOnline: '100 AED',
        priceOfEventRuOnline :'2,000 RUB', 
        priceDescription: 'Откройте тёмную сторону известности исследовав покушения на публичных фигур на протяжении истории: от шокирующего убийства Джона Кеннеди до современных проблем безопасности. ',
        stripeLink: 'https://buy.stripe.com/cN2g0KgkD8CJdfa9Bs', 
        kassaLink: 'https://yookassa.ru/my/i/aAE-k1F-qcBS/l',
        image:P3E2B1,
        listOfBenefits: [
          'Офлайн Занятие',
          'Q&A с Мастером', 
          'Напитки и закуски'
        ],
        keyTakeaways: [
          {
            title: 'Связь между известностью, влиянием и риском',
            description: 'Узнайте, как публичность делает людей уязвимыми, и какие механизмы используются для снижения связанных с этим рисков.'
          },
          {
            title: 'Понимание психологии покушений',
            description: 'Изучите образ мышления тех, кто и почему нападает на влиятельных людей, а также откройте связь с более широкими социальными и политическими событиями.'
          },
          {
            title: 'Критический взгляд на исторические события',
            description: 'Отделите факты от домыслов, получив более глубокое и обоснованное понимание их влияния на историю и общество.'
          },
          {
            title: 'Применение уроков к современности',
            description: 'Используйте знания об исторических покушениях для лучшего понимания современных угроз безопасности в мире, где социальные сети сделали известными практически всех.'
          }
        ]
      },
      {
        id: 'P3E3B1',
        eventMaster:'Денис Кобба ',
        name: 'Рим: От Рассвета до Заката',
        shortDescription: 'Погрузитесь в драматическую историю взлета и падения Рима — от скромного поселения до величайшей империи в истории. Узнайте, как власть, амбиции и рок сформировали судьбу Вечного города.',
        description: 'Взлёт и падение Рима — одна из величайших историй человечества — империи, которая сформировала мир, чтобы затем рухнуть под собственной тяжестью. От небольшого поселения на Тибре до самой могущественной цивилизации своего времени.  Восхождение Рима определялось военными завоеваниями, политическими амбициями и новаторскими достижениями. Но какие силы привели к его упадку? Было ли это неизбежным, или история могла пойти по другому пути? Эта лекция исследует ключевые моменты, определившие путь Рима, от его легендарного основания Ромулом до последних дней при Ромуле Августуле. Опираясь на свой анализ в области исторических властных структур, Денис Кобба раскрывает политическую борьбу, общественные сдвиги и внешнее давление, определившие судьбу Рима. С помощью данной лекции, откройте для себя, как уроки триумфов и неудач Рима продолжают проявлять себя и в современном мире. ',
       date: '14  Мая',
       dateOfEvent: '2025-05-14',
        time: '19:00 ',
        location: 'Zoom', 
        eventType:'Онлайн',
        locationLink: 'https://maps.app.goo.gl/TFGEStx1q5qb8krG9',
        priceOfEvent: '100 AED',
        priceOfEventRu :'2,000 RUB',
        priceDescription: 'Раскройте для себя драматический взлёт и падение Рима, от скромного поселения до величайшей в истории империи. Узнайте, как власть, амбиции и судьба определили путь вечного города. ',
        stripeLink: 'https://buy.stripe.com/00g7ueb0jaKRcb68xk',
        kassaLink: 'https://yookassa.ru/my/i/aAE-LJq9vY2x/l',
        image:P3E3B1,
        listOfBenefits: [
          'Офлайн Занятие',
          'Q&A с Мастером', 
          'Напитки и закуски'
        ],
        keyTakeaways: [
          {
            title: 'Анализ причин упадка империи',
            description: 'Исследуйте, было ли падение Рима неизбежным или же это результат решений, которых можно было избежать, извлекая уроки, применимые к современным цивилизациям.'
          },
          {
            title: 'Погружение в увлекательные исторические повествования',
            description: 'Прочувствуйте драму истории Рима — от его легендарного основания до последних дней — через захватывающее повествование и экспертный анализ.'
          },
          {
            title: 'Раскрытие политических и военных стратегий Рима',
            description: 'Узнайте, как лидерство, военное дело и управление сыграли ключевую роль как в расширении империи, так и в её последующем крахе.'
          },
          {
            title: 'Проведение параллелей между прошлым и настоящим',
            description: 'Распознайте предупреждающие знаки упадка могущественных держав и то, как уроки, извлечённые из истории Рима, остаются актуальными в современном глобальном ландшафте.'
          }
        ]
      }, 
      {
        id: 'P3E1B1',
        eventMaster:'Денис Кобба ',
        name: 'Масоны без Мистики и Теорий Заговора.',
        shortDescription: 'Исследуйте происхождение и генезис института тайных обществ, их влияние и значение с древнейших времен до XXI века. Раскройте историю влияние масонства на мир вокруг нас, отделяя объективные факты от вымысла, чтобы понять их истинную роль в формировании общества.',
        description:
          ' Отправьтесь в увлекательное расследование таинственного мира тайных обществ, уделяя особое внимание масонам — одной из самых влиятельных и противоречивых организаций в истории. Исследуйте их истоки, прослеживая путь от средневековых цехов каменщиков до современных братских объединений, и оцените их влияние на политические, культурные и интеллектуальные движения. Опираясь на уникальный взгляд Дениса Коббы — академического историка и преподавателя Академии ФСБ, — мы разберём исторические свидетельства, чтобы отделить мифы от реальности. Раскроем ритуалы, символику и философию, определяющие сущность масонов. Оценим их влияние в 21-ом веке, задаваясь вопросом: сохраняют ли эти загадочные традиции свою силу в современном мире?',
        date: '28 Мая',
        dateOfEvent: '2025-05-28',
        time: '19:00 ',
        location: 'Zoom', 
        eventType:'Онлайн',
        locationLink: 'https://maps.app.goo.gl/TFGEStx1q5qb8krG9',
        priceOfEvent: '100 AED',
        priceOfEventRu :'2,000 RUB',
        priceDescription: 'Исследуйте влияние и актуальность тайных обществ в 21-ом веке. Раскрывая историю и влияние масонов, отделяя факты от вымысла, чтобы понять их истинную роль в формировании общества. ',
        stripeLink: 'https://buy.stripe.com/9AQbKu8SbbOVfnibJD',
        kassaLink: 'https://yookassa.ru/my/i/aAE-dlFPvQFN/l',
        image:P3E1B1,
        listOfBenefits: [
          'Офлайн Занятие',
          'Q&A с Мастером', 
          'Напитки и закуски'
        ],
        keyTakeaways: [
          {
            title: 'Понимание политического и культурного влияния',
            description: 'Узнайте, как масоны повлияли на ключевые исторические события, движения и идеологии.'
          },
          {
            title: 'Расшифровка символов и ритуалов',
            description: 'Изучите значение масонских символов, традиций и их скрытый смысл.'
          },
          {
            title: 'Современная актуальность тайных обществ',
            description: 'Исследуйте роль масонов в современном мире и их продолжающееся культурное влияние.'
          },
          {
            title: 'Увлекательное и побуждающее к размышлениям исследование',
            description: 'Подвергните сомнению общепринятые представления и откройте скрытые аспекты многовековой традиции.'
          }
        ]
      },
  
  
      
    ],
    noOfEvents: 0, // Placeholder
  },
  {
    id: 'program4',
    title: 'Российская Идентичность: Искусство, Влияние и Культурная Сила',
    image: P4,
    programMasterImage:m4,
    dateRange: '4 марта - 9 мая ',
    startDate: '2025-03-04',
    category: 'Culture',
    whatsIncluded: [
      'Офлайн Занятие',
          'Q&A с Мастером', 
          'Напитки и закуски'
    ],
    price: '1,800 AED',
    masterId: 'm4',
    Masters: 'Анна Эспарса', // References Master by ID
    description:
      'От литературы и лидерства до музыки и кухни - этот курс раскрывает культурные силы, которые сформировали российскую идентичность и продолжают вдохновлять мир. Под руководством известного ученого Анны Эспарса вы изучите непреходящую силу русской литературы, скрытое влияние женщин, стоящих у власти, и вечный язык классической музыки. Благодаря редким архивным материалам, виртуозным композициям и даже уникальной лекции-дегустации вы узнаете, как искусство, власть и рассказ переплетаются в истории России. Внимательно следите за экспертным анализом Анны Эспарса, которая оживляет эти темы, раскрывая глубокие связи между творчеством, влиянием и национальной идентичностью. ',
   
    stripeLink: 'https://buy.stripe.com/28o4i28Sbf17fni5kk',
    events: [
      
  
    
    ],
    noOfEvents: 0, // Placeholder
  },
];

// Update `noOfEvents` dynamically before exporting
Programs.forEach((program) => {
  program.noOfEvents = program.events.length;
});

export { Programs };
